import { createContext, useContext } from 'react'

const RefContext = createContext<string | null>(null)

export function useLocationRef(): string {
	const ref = useContext(RefContext)
	if (ref === null) throw new Error('useLocationRef must be used within RefLayout')
	return ref
}

export default RefContext
